import {
  AppBar,
  Box,
  Button,
  ClickAwayListener,
  Grow,
  IconButton,
  makeStyles,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Toolbar,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Hambaga from "../assets/images/hamburger.png";
import DaiLogo from "../assets/images/daikokuLogo.png";
import JuicyTomato from "../assets/images/navtomato.png";
const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 500,
    boxShadow: "none",
  },
  appBar: {
    margin: "auto",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  button: {
    height: "63px",
    boxShadow: "none",
    fontSize: "16px",
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.main,
    "&:hover": {
      boxShadow: "none",
      backgroundColor: "rgba(255,245,245,0.5)",
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: "rgb(205, 215, 179)",
    },
  },
  buttonActive: {
    boxShadow: "none",
    backgroundColor: "rgb(205, 215, 179)", //
  },
  imgLogo: {
    height: "63px",
  },
  imgTomato: {
    height: "54px",
  },

  imgBox: {
    flexGrow: 1,
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },

  buttonLink: {
    flexGrow: 1,
    align: "center",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  menuButton: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "inline-flex",
    },
  },
  paper: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.main,
  },
  navMenu: {
    border: `2px solid ${theme.palette.primary.main}`,
  },
  menuItem: {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    "&:last-child": {
      borderBottom: "none",
    },
    "&:hover": {
      backgroundColor: "rgba(255,245,245,0.5)",
    },
  },
}));
export default function NavigationBar() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const handleToggle = () => {
    setOpen((o) => !o);
  };
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }
  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <AppBar color="secondary" className={classes.root} position="static">
      <Toolbar>
        <IconButton
          component={Link}
          to="/"
          edge="start"
          className={classes.imgLogo}
          color="inherit"
          aria-label="open drawer"
        >
          <img src={DaiLogo} alt="Daikuko" />
        </IconButton>

        <div
          style={{
            flexGrow: 1,
          }}
        />
        <Box className={classes.buttonLink}>
          <StyleButtonLink name="会社概要" url="/about" classes={classes} />
          <StyleButtonLink
            name="事業紹介"
            url="/information"
            classes={classes}
          />
          <StyleButtonLink
            name="取扱商品一覧"
            url="/vegetablesItem"
            classes={classes}
          />

          <StyleButtonLink name="大国通信" url="/news" classes={classes} />
          <StyleButtonLink name="発注" url="/order" classes={classes} />
          <StyleButtonLink name="採用情報" url="/recruit" classes={classes} />
          <StyleButtonLink
            name="お問い合わせ"
            url="/contact"
            classes={classes}
          />
        </Box>
        <div
          style={{
            flexGrow: 1,
          }}
        />
        <IconButton
          edge="end"
          className={classes.menuButton}
          color="inherit"
          aria-label="open drawer"
          ref={anchorRef}
          aria-controls={open ? "menu-list-grow" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <img src={Hambaga} alt="hamburger" />
        </IconButton>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
          color="primary"
          style={{ marginRight: "15px", zIndex: 499 }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper className={classes.paper}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="menu-list-grow"
                    onKeyDown={handleListKeyDown}
                    className={classes.navMenu}
                  >
                    <PopperLink
                      name="会社概要"
                      url="/about"
                      classes={classes}
                    />
                    <PopperLink
                      name="取扱商品一覧"
                      url="/vegetablesItem"
                      classes={classes}
                    />
                    <PopperLink name="大国通信" url="/news" classes={classes} />
                    <PopperLink name=" 発注" url="/order" classes={classes} />
                    <PopperLink
                      name="採用情報"
                      url="/recruit"
                      classes={classes}
                    />
                    <PopperLink
                      name="お問い合わせ"
                      url="/contact"
                      classes={classes}
                    />
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Toolbar>
    </AppBar>
  );
}

const PopperLink = ({ name, url, classes }) => (
  <MenuItem component={Link} to={url} className={classes.menuItem}>
    <img src={JuicyTomato} alt="tomato" style={{ marginRight: "15px" }} />{" "}
    {name}
  </MenuItem>
);

const StyleButtonLink = ({ name, url, classes }) => (
  <Button
    component={NavLink}
    to={url}
    variant="contained"
    className={classes.button}
    activeClassName={classes.buttonActive}
  >
    {name}
  </Button>
);
